import React from 'react';

import { useFilterStorage } from 'src/hooks/common';
import { usePeoStaffList, usePeoStaffListQueryVariables } from 'src/hooks/peoStaff';
import { ResendInviteModal } from 'src/modals/invite';
import { InvitePeoStaffByCVStaffModal } from 'src/modals/peoStaff';

import { PeoStaffTable } from '../PeoStaffTable';

interface PeosDetailsStaffTablePlatformStaffProps {
  peoId: string | undefined;
}

export const PeosDetailsStaffTablePlatformStaff: React.FC<
  PeosDetailsStaffTablePlatformStaffProps
> = ({ peoId }) => {
  const { pagination } = useFilterStorage();

  const queryVariables = usePeoStaffListQueryVariables(peoId);
  const { peoStaffsList, peoStaffsCount, loading, refetch } = usePeoStaffList(
    queryVariables,
    !peoId,
    true,
  );

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  return (
    <React.Fragment>
      <PeoStaffTable
        peoStaffList={peoStaffsList}
        peoStaffCount={peoStaffsCount}
        pagination={pagination}
        onRefresh={refetchData}
        loading={loading}
      />

      <InvitePeoStaffByCVStaffModal />
      <ResendInviteModal />
    </React.Fragment>
  );
};
